import { useMutation } from '@apollo/client'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'
import { CreatorAvatar } from '~/components/business/CreatorAvatar'
import FollowBtn from '~/components/business/FollowBtn'
import { MyBtn } from '~/components/ui/MyBtn'
import { MyDivide } from '~/components/ui/MyDivide'
import { MyModal } from '~/components/ui/MyModal'
import { FOLLOW, GET_ORDER_INFO } from '~/graphqls/gqls'
import {
  follow,
  FollowStatus,
  followVariables,
  getOrderInfo,
  getOrderInfoVariables,
  getOrderInfo_orderModule_copyrightOrder,
  SkuType,
} from '~/graphqls/types'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { FenToYuan } from '~/utils'
import { useStores } from '~/hooks/useStores'
import { observer } from 'mobx-react'
import { SkuTypeName } from '~/configs'

export const OrderSuccessModal: React.FC<{
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  orderNo: string
}> = observer(({ visible, setVisible, orderNo }) => {
  const [mounted, setMounted] = useState(false)
  const { store } = useStores()

  const [orderInfo, setOrderInfo] = useState<
    getOrderInfo_orderModule_copyrightOrder | null | undefined
  >()

  const isSelf =
    store.userinfo?.base?.uid === orderInfo?.blindBoxInfo?.creator?.id

  const [followAction] = useMutation<follow, followVariables>(FOLLOW)

  const getOrderInfoQuery = useImperativeQuery<
    getOrderInfo,
    getOrderInfoVariables
  >(GET_ORDER_INFO)

  useEffect(() => {
    if (!mounted) {
      getOrderInfoQuery({
        orderNo: orderNo,
      }).then(data => {
        setOrderInfo(data.data.orderModule?.copyrightOrder)

        if (
          store.userinfo?.base?.uid !==
          data.data.orderModule?.copyrightOrder?.blindBoxInfo?.creator?.id
        ) {
          followAction({
            variables: {
              param: {
                followUid:
                  data.data.orderModule?.copyrightOrder?.blindBoxInfo?.creator
                    ?.id,
              },
            },
          })
        }

        setMounted(true)
      })
    }
  }, [mounted])

  return (
    <>
      {mounted && (
        <MyModal
          visible={visible}
          title="支付成功"
          onCancel={() => {
            setVisible(false)
            location.reload()
          }}
          maskStyle={{
            backgroundColor: 'rgba(0,0,0,0.8)',
          }}
          width={448}
          footer={null}
        >
          <div className="text-center mb-6">
            <img
              src="/images/order/success.png"
              className="h-[120px] mb-2"
              alt=""
            />
            <br />
            <span className="text-xs text-neutral-400">订单支付成功</span>
          </div>
          <div className="bg-neutral-700 rounded-xl px-4 py-3 text-sm text-neutral-400 mb-4">
            <div className="flex justify-between">
              <span>作品名称</span>
              <span className="text-neutral-200">
                {orderInfo?.blindBoxInfo?.name}
              </span>
            </div>
            <div className="flex justify-between mt-2">
              <span>购买类型</span>
              <span className="text-neutral-200">
                {SkuTypeName[SkuType.OWNER]}
              </span>
            </div>
            <div className="flex justify-between mt-2">
              <span>创作者</span>
              <span className="text-neutral-200">
                {orderInfo?.blindBoxInfo?.creator?.name}
              </span>
            </div>
            <div className="flex justify-between mt-2">
              <span>卖家</span>
              <span className="text-neutral-200">
                {orderInfo?.seller?.name}
              </span>
            </div>
            <div className="flex justify-between mt-2">
              <span>实付</span>
              <span className="text-error">
                {orderInfo?.totalPoint > 0
                  ? `¥${FenToYuan(orderInfo?.totalFee)} + ${
                      orderInfo?.totalPoint
                    }积分`
                  : `¥${FenToYuan(orderInfo?.totalFee)}`}
              </span>
            </div>
          </div>
          {!isSelf && (
            <div className="bg-neutral-700 rounded-xl px-4 py-3 flex justify-between items-center">
              <div className="flex">
                <CreatorAvatar
                  image={orderInfo?.blindBoxInfo?.creator?.avatar as string}
                  iconClassName="h-[16px] -right-[3px] max-w-[24px]"
                  userRole={orderInfo?.product?.creator?.userRoleInfo}
                  size={48}
                ></CreatorAvatar>
                <div className="ml-2 w-[200px]">
                  <div className="text-sm text-neutral-200 mb-1">
                    {orderInfo?.blindBoxInfo?.creator?.name}
                  </div>
                  <div className="text-xs text-neutral-400  line-clamp-1">
                    {orderInfo?.blindBoxInfo?.creator?.description}
                  </div>
                </div>
              </div>
              <FollowBtn
                status={FollowStatus.ME_ONE_WAY}
                targetId={orderInfo?.blindBoxInfo?.creator?.id}
              />
            </div>
          )}

          <MyDivide className="mt-10 mb-3" />
          <Link href="/my/trade-history">
            <a>
              <MyBtn type="primary" block>
                查看交易记录
              </MyBtn>
            </a>
          </Link>
        </MyModal>
      )}
    </>
  )
})
